<template>
    <div class="filter weekly-wrapper mx-auto mx-md-0" ref="weeklyNav">
        <div v-if="formattedDateRange" class="date-navigation d-flex me-2" id="weekly-date">
            <span
                :class="`cursor-pointer px-2 ${disabled || isPrevDisabled ? 'disabled' : ''}`"
                @click="backwardNavigation()"
            >
                <i class="fas fa-chevron-left date-change-icon cursor-pointer"></i>
            </span>

            <span class="mx-2 formatted-date">{{ formattedDateRange }}</span>

            <span :class="`calendar-icon cursor-pointer px-1 ${showCalendar ? 'active' : ''}`" @click="toggleCalendar">
                <i :class="`fas fa-calendar-alt ${showCalendar ? 'active' : ''}`"></i>
            </span>

            <span
                :class="`cursor-pointer px-2 ${disabled || isNextDisabled ? 'disabled' : ''}`"
                @click="forwardNavigation()"
            >
                <i class="fas fa-chevron-right date-change-icon cursor-pointer"></i>
            </span>

            <div class="weekly-picker text-dark" v-show="showCalendar">
                <div ref="weekDatePicker" class="schedule-calendar"></div>
            </div>
        </div>
    </div>
</template>

<style src="./WeeklyDateNavigation.scss"></style>
<script lang="ts" src="./WeeklyDateNavigation.ts"></script>
